import {Footer} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/navigation_bar.types';
import {SectionFooter} from '@aboutyou/ui-components';
import React from 'react';
import {useTrackFlyoutOriginClick} from '../../../hooks/useOriginClickTrackingFunction';

interface LogoSectionFooterProps {
  footer: Footer;
  className?: string;
}

export const LogoSectionFooter = ({
  footer,
  className,
}: LogoSectionFooterProps) => {
  const trackOriginClick = useTrackFlyoutOriginClick();

  return (
    <SectionFooter
      key={`logoSectionItemFooter`}
      dataTestId={`logoSectionItemFooter`}
      onLinkItemClick={trackOriginClick}
      label={footer.label}
      url={footer.url.url}
      className={className}
    />
  );
};
